<template>
  <TheSignin />
</template>

<script>
import TheSignin from '@/components/Signin/TheSignin.vue'

export default {
  name: 'SigninPage',

  components: { TheSignin }
}
</script>
